import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import {
  Paper,
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
  Grid,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

import ToggleTextField from '../../components/toggleTextField';
import Selector from '../../components/selector';
import { useAPI } from '../../utils/api';
import { useAuth } from '../../utils/auth';
import { useDialog } from '../../utils/dialog';

const RecordEditPage = () => {
  const api = useAPI();
  const dialog = useDialog();
  const { orderID } = useParams();
  const auth = useAuth();
  const inputTotalShipReference = useRef(null);
  const inputTaxReference = useRef(null);
  const inputNeedPayShipReference = useRef(null);
  const inputShippingRatePriceReference = useRef(null);
  const inputBaseShippingCostReference = useRef(null);

  const [isUnmounted, setIsUnmounted] = useState(false);
  const [invoiceTypes, setInvoiceTypes] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const [orderData, setOrderData] = useState();
  const [shouldPageUpdated, setShouldPageUpdated] = useState(false);

  const saveChange = (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    const data = {
      order_id: orderData.order.id,
      order: {
        filled_by_client: formData.get('filledByClient') === 'true',
        member_id: auth.user.isAdmin ? Number.parseInt(auth.user.memberID) : -1,
        sender_note: '',
        receive_note: '',
        delivery_method: formData.get('deliveryMethod') || '',
        payment_method: formData.get('paymentMethod') || '',
        order_note: formData.get('orderNote') || '',
      },
      order_ext: {
        special_sub_account: formData.get('specialSubAccount') || '',
        agency_receipt_amount:
          Number.parseInt(formData.get('agencyReceiptAmount')) || 0,
        too_fast_prepaid_amount:
          Number.parseInt(formData.get('tooFastPrepaidAmount')) || 0,
        sender_refill_amount:
          Number.parseInt(formData.get('senderRefillAmount')) || 0,
        receiver_refill_amount:
          Number.parseInt(formData.get('receiverRefillAmount')) || 0,
        shipping_rate_price:
          Number.parseInt(inputShippingRatePriceReference.current.value) || 0,
        base_shipping_cost:
          Number.parseInt(inputBaseShippingCostReference.current.value) || 0,
        size_increase_amount:
          Number.parseInt(formData.get('sizeIncreaseAmount')) || 0,
        weight_increase_amount:
          Number.parseInt(formData.get('weightIncreaseAmount')) || 0,
        insurance_amount: Number.parseInt(formData.get('insuranceAmount')) || 0,
        non_VIP_additional_fee:
          Number.parseInt(formData.get('nonVIPAdditionalFee')) || 0,
        send_distance_charge: formData.get('sendDistanceCharge') || 0,
        receive_distance_charge: formData.get('receiveDistanceCharge') || 0,
        send_wait_charge: formData.get('sendWaitCharge') || 0,
        receive_wait_charge: formData.get('receiveWaitCharge') || 0,
        send_useless_charge: formData.get('sendUselessCharge') || 0,
        receive_useless_charge: formData.get('receiveUselessCharge') || 0,
        send_wrong_point_charge: formData.get('sendWrongPointCharge') || 0,
        receive_wrong_poing_charge:
          formData.get('receiveWrongPoingCharge') || 0,
        send_special_point_charge: formData.get('sendSpecialPointCharge') || 0,
        receive_speical_point_chage:
          formData.get('receiveSpeicalPointChage') || 0,
        send_hard_point_charge: formData.get('sendHardPointCharge') || 0,
        receive_hard_point_charge: formData.get('receiveHardPointCharge') || 0,
        send_other_charge: formData.get('sendOtherCharge') || 0,
        receive_other_charge: formData.get('receiveOtherCharge') || 0,
        total_shipping_cost:
          Number.parseInt(formData.get('totalShippingCost')) || 0,
        tax_amount: Number.parseInt(formData.get('taxAmount')) || 0,
        receivable_amount:
          Number.parseInt(formData.get('receivableAmount')) || 0,
      },
      order_invoice: {
        invoice_type: Number.parseInt(formData.get('invoiceType')),
        company_title: formData.get('companeyTitle'),
        tax_id_number: formData.get('taxID'),
      },
    };

    api
      .updateOrderRecord(data)
      .then((response) => {
        dialog.openAlert({ message: '更新成功' });
        inputTotalShipReference.current.value = response.totalShippingCost;
      })
      .catch(() => {});

    data;
    api;
  };

  useEffect(() => {
    api
      .getInvoiceType()
      .then((list) => {
        if (!isUnmounted) {
          setInvoiceTypes(list);
        }
      })
      .catch(() => {});

    api
      .getDropdownPaymentMethods()
      .then((list) => {
        if (!isUnmounted) {
          setPaymentMethods(list);
        }
      })
      .catch(() => {});

    api
      .getOrderDeliveryMethods()
      .then((list) => {
        if (!isUnmounted) {
          setDeliveryMethods(list);
        }
      })
      .catch(() => {});

    api
      .getEditOrderByOrderId({ id: orderID })
      .then((order) => {
        if (!isUnmounted) {
          // console.log('order', JSON.stringify(order.order_ext));
          setOrderData(order);
          setShouldPageUpdated(true);
          // setExOrderData(order.order_ext);
        }
      })
      .catch(() => {});

    return () => {
      setIsUnmounted(true);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      setShouldPageUpdated(false);
    };
  }, [shouldPageUpdated]);

  const setDeliveryFee = (checked, textFieldName, textFieldValue) => {
    const total = Number.parseInt(inputTotalShipReference.current.value);

    inputTotalShipReference.current.value = checked
      ? total + Number.parseInt(textFieldValue)
      : total - Number.parseInt(textFieldValue);

    inputTaxReference.current.value = Math.floor(
      inputTotalShipReference.current.value * 0.05
    );
    inputNeedPayShipReference.current.value =
      Number.parseInt(inputTotalShipReference.current.value) +
      Number.parseInt(inputTaxReference.current.value);
  };

  return (
    <>
      {!shouldPageUpdated ? (
        <Box
          component="form"
          noValidate
          onSubmit={saveChange}
          sx={{
            padding: { xs: 1, sm: 2, md: 3, lg: 4 },
            maxWidth: '900px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Paper
            elevation={4}
            sx={{
              width: '100%',
              padding: 2,
              paddingBottom: 0,
              marginBottom: 4,
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            <Box variant="body" marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                案件序號：
              </Typography>
              <Typography display="inline">
                {orderData && orderData.order ? orderData.order.id : ''}
              </Typography>
            </Box>
            <Box variant="body" marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                登錄日期：
              </Typography>
              <Typography display="inline">
                {orderData && orderData.order
                  ? orderData.order.creation_time
                  : ''}
              </Typography>
            </Box>
            <Box variant="body" marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                案件狀態：
              </Typography>
              <Typography display="inline">
                {orderData && orderData.order
                  ? orderData.order.order_status
                  : ''}
              </Typography>
            </Box>
            <Box variant="body" marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                付款方：
              </Typography>
              <Typography display="inline">
                {orderData && orderData.order
                  ? orderData.order.mandarin_name
                  : ''}
              </Typography>
            </Box>
          </Paper>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' },
              columnGap: { xs: 0, lg: 2 },
              rowGap: { xs: 2, lg: 0 },
              marginBottom: 4,
            }}
          >
            <Box sx={{ position: 'relative' }}>
              <Card elevation={4} sx={{ minWidth: 200, height: '100%' }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    component="div"
                    fontWeight="bold"
                    marginBottom={2}
                  >
                    寄件方
                  </Typography>
                  <Box sx={{ paddingLeft: 2 }}>
                    <Typography
                      component="div"
                      variant="body1"
                      fontWeight="bold"
                      marginBottom={1}
                    >
                      {orderData && orderData.order
                        ? orderData.order.sender_name
                        : ''}
                    </Typography>
                    <Typography component="div" variant="body2" padding={1}>
                      <Typography
                        component="div"
                        variant="body2"
                        marginBottom={1}
                      >
                        {orderData && orderData.order
                          ? orderData.order.sender_company_name
                          : ''}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        marginBottom={1}
                      >
                        {orderData && orderData.order
                          ? orderData.order.sender_phone
                          : ''}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        marginBottom={1}
                      >
                        {orderData && orderData.order
                          ? orderData.order.sender_address
                          : ''}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        marginBottom={1}
                      >
                        {orderData && orderData.order
                          ? orderData.order.sender_pickup_datetime
                          : ''}
                      </Typography>
                      {/* <TextField
                        name="senderNote"
                        label="備註"
                        text={
                          orderData && orderData.order
                            ? orderData.order.sender_note
                            : ''
                        }
                        fullWidth
                        required
                      /> */}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Box sx={{ position: 'relative' }}>
              <Card elevation={4} sx={{ minWidth: 200, height: '100%' }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    component="div"
                    fontWeight="bold"
                    marginBottom={2}
                  >
                    收件方
                  </Typography>
                  <Box sx={{ paddingLeft: 2 }}>
                    <Typography
                      component="div"
                      variant="body1"
                      fontWeight="bold"
                      marginBottom={1}
                    >
                      {orderData && orderData.order
                        ? orderData.order.receiver_name
                        : ''}
                    </Typography>
                    <Typography component="div" variant="body2" padding={1}>
                      <Typography
                        component="div"
                        variant="body2"
                        marginBottom={1}
                      >
                        {orderData && orderData.order
                          ? orderData.order.receiver_company_name
                          : ''}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        marginBottom={1}
                      >
                        {orderData && orderData.order
                          ? orderData.order.receiver_phone
                          : ''}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        marginBottom={1}
                      >
                        {orderData && orderData.order
                          ? orderData.order.receiver_address
                          : ''}
                      </Typography>
                      {/* <TextField
                        name="receiveNote"
                        label="備註"
                        text={
                          orderData && orderData.order
                            ? orderData.order.receive_note
                            : ''
                        }
                        fullWidth
                        required
                      /> */}
                      {/* <Typography
                        component="div"
                        variant="body2"
                        marginBottom={1}
                      >
                        2021/07/15 14:50:00
                      </Typography> */}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Box>

          <Paper
            elevation={4}
            sx={{
              padding: 2,
              paddingBottom: 4,
              mb: 4,
            }}
          >
            <Typography sx={{ mb: 1, textAlign: 'center' }}>
              基本資料
            </Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6} md={4}>
                <Selector
                  label="付款方式"
                  placeHolder="付款方式"
                  name="paymentMethod"
                  defaultValue={
                    orderData && orderData.order
                      ? orderData.order.payment_method
                      : 0
                  }
                  options={paymentMethods}
                  variant="outlined"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Selector
                  label="派送方式"
                  placeHolder="派送方式"
                  name="deliveryMethod"
                  defaultValue={
                    orderData && orderData.order
                      ? orderData.order.delivery_method
                      : 0
                  }
                  options={deliveryMethods}
                  variant="outlined"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="orderNote"
                  label="進件備註"
                  defaultValue={
                    orderData && orderData.order
                      ? orderData.order.order_note
                      : ''
                  }
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="shippingRatePrice"
                  inputRef={inputShippingRatePriceReference}
                  label="費率金額"
                  fullWidth
                  required
                  variant={'filled'}
                  disabled
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.shipping_rate_price
                      : 0
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="baseShippingCost"
                  inputRef={inputBaseShippingCostReference}
                  label="基本費率"
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.base_shipping_cost
                      : 0
                  }
                  variant={'filled'}
                  disabled
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="specialSubAccount"
                  label="特殊分帳"
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.special_sub_account
                      : 0
                  }
                  fullWidth
                  required
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="filledByClient"
                      checked={
                        orderData && orderData.order
                          ? orderData.order.filled_by_client
                          : false
                      }
                      value="true"
                      color="primary"
                    />
                  }
                  label="客自填"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="sizeIncreaseAmount"
                  label="加大(才)"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.size_increase_amount
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="weightIncreaseAmount"
                  label="加重(kg)"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.weight_increase_amount
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="insuranceAmount"
                  label="保值"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.insurance_amount
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="nonVIPAdditionalFee"
                  label="非會員"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.non_VIP_additional_fee
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="agencyReceiptAmount"
                  label="代收款"
                  type="number"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.agency_receipt_amount
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="tooFastPrepaidAmount"
                  label="代墊款"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.too_fast_prepaid_amount
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="senderRefillAmount"
                  label="送順收帳款"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.sender_refill_amount
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="receiverRefillAmount"
                  label="取順收帳款"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receiver_refill_amount
                      : 0
                  }
                />
              </Grid>
            </Grid>

            <Typography sx={{ mb: 1, textAlign: 'center' }}>
              取送加註
            </Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="receiveDistanceCharge"
                  label="取件加程"
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receive_distance_charge
                      : 0
                  }
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  type="number"
                  autoComplete="none"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="receiveWaitCharge"
                  label="取件等件"
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receive_wait_charge
                      : 0
                  }
                  autoComplete="none"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="sendDistanceCharge"
                  label="送件加程"
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  autoComplete="none"
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.send_distance_charge
                      : 0
                  }
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="sendWaitCharge"
                  label="送件等件"
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  autoComplete="none"
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.send_wait_charge
                      : 0
                  }
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="receiveUselessCharge"
                  label="取件空跑"
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receive_useless_charge
                      : 0
                  }
                  autoComplete="none"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="receiveWrongPoingCharge"
                  label="取件地誤"
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receive_wrong_poing_charge
                      : 0
                  }
                  autoComplete="none"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="sendUselessCharge"
                  label="送件空跑"
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.send_useless_charge
                      : 0
                  }
                  autoComplete="none"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="sendWrongPointCharge"
                  label="送件地誤"
                  autoComplete="none"
                  required
                  fullWidth
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.send_wrong_point_charge
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="receiveSpeicalPointChage"
                  label="取件特殊點"
                  autoComplete="none"
                  required
                  fullWidth
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receive_speical_point_chage
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="receiveHardPointCharge"
                  label="取件山區"
                  autoComplete="none"
                  required
                  fullWidth
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receive_hard_point_charge
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="sendSpecialPointCharge"
                  label="送件特殊點"
                  autoComplete="none"
                  required
                  fullWidth
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.send_special_point_charge
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="sendHardPointCharge"
                  label="送件山區"
                  autoComplete="none"
                  required
                  fullWidth
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.send_hard_point_charge
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="receiveOtherCharge"
                  label="取件其他"
                  autoComplete="none"
                  required
                  fullWidth
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receive_other_charge
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleTextField
                  checkboxName=""
                  textFieldName="sendOtherCharge"
                  label="送件其他"
                  autoComplete="none"
                  type="number"
                  onCheckChange={setDeliveryFee}
                  onBlur={setDeliveryFee}
                  required
                  fullWidth
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.send_other_charge
                      : 0
                  }
                />
              </Grid>
            </Grid>

            <Typography sx={{ mb: 1, textAlign: 'center' }}>結算</Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="totalShippingCost"
                  label="合計運費"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  inputRef={inputTotalShipReference}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.total_shipping_cost
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="taxAmount"
                  label="稅額"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  inputRef={inputTaxReference}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.tax_amount
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="receivableAmount"
                  label="應收金額"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  inputRef={inputNeedPayShipReference}
                  defaultValue={
                    orderData && orderData.order_ext
                      ? orderData.order_ext.receivable_amount
                      : 0
                  }
                />
              </Grid>
            </Grid>

            <Typography sx={{ mb: 1, textAlign: 'center' }}>發票</Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6} md={4}>
                <Selector
                  label="發票類型"
                  placeHolder="發票類型"
                  name="invoiceType"
                  options={invoiceTypes}
                  variant="outlined"
                  required
                  fullWidth
                  defaultValue={
                    orderData && orderData.order_invoice
                      ? orderData.order_invoice.invoice_type
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="companeyTitle"
                  label="抬頭"
                  type="text"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_invoice
                      ? orderData.order_invoice.company_title
                      : 0
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="taxID"
                  label="統編"
                  type="tel"
                  autoComplete="none"
                  fullWidth
                  required
                  defaultValue={
                    orderData && orderData.order_invoice
                      ? orderData.order_invoice.tax_id_number
                      : 0
                  }
                />
              </Grid>
            </Grid>
            <Typography sx={{ mb: 1, textAlign: 'center' }}>
              電子簽單
            </Typography>
            <Grid item xs={12} sm={6} md={4}>
              <img
                src={
                  orderData && orderData.order
                    ? orderData.order.order_picture
                    : ''
                }
                alt={'查無電子簽單'}
              />
            </Grid>
          </Paper>
          <Box sx={{ textAlign: 'center' }}>
            <Button
              type="submit"
              variant="contained"
              color="success"
              sx={{ color: 'white', minWidth: '120px' }}
            >
              儲存
            </Button>
          </Box>
        </Box>
      ) : undefined}
    </>
  );
};

export default RecordEditPage;
